import { is768Query } from '~/core/scripts/mediaquery-helper';

let config = [{
  name: 'afdmap',
  label: 'AfD',
  description: 'Wo die AfD ihre Hochburgen hat - und wo keine Chance',
  map: 'AfD'
}, {
  name: 'spdmap',
  label: 'SPD',
  description: 'Wo die SPD ihre Hochburgen hat - und wo keine Chance',
  map: 'SPD'
}, {
  name: 'cdumap',
  label: 'CDU',
  description: 'Wo die CDU ihre Hochburgen hat - und wo keine Chance',
  map: 'CDU'
}, {
  name: 'gruenmap',
  label: 'Grüne',
  description: 'Wo die Grüne ihre Hochburgen hat - und wo keine Chance',
  map: 'Grüne'
}, {
  name: 'linkemap',
  label: 'Linke',
  description: 'Wo die Die.Linke ihre Hochburgen hat - und wo keine Chance',
  map: 'Die.Linke'
}, {
  name: 'fwmap',
  label: 'BVB/FW',
  description: 'Wo die BVB/Freien Wähler ihre Hochburgen haben - und wo keine Chance',
  map: 'BVB.Freie.Wähler'
}/*{
  name: 'secondplace',
  label: 'Zweitbester',
  description: 'Welche Partei diesmal auf dem zweiten Platz gelandet ist',
  icon: 'second'
}, {
  name: 'thirdplace',
  label: 'Platz drei',
  description: 'Wer bei dieser Wahl die drittstärkste Kraft geworden ist',
  icon: 'third',
}, {
  name: 'close',
  label: 'Knappes Ergebnis',
  description: 'Hier haben nur wenige Stimmen das Wahlrennen entschieden',
  icon: 'stats2'
}, {
  name: 'change',
  label: 'Wechselwähler',
  description: 'Wo eine andere Partei als bei der Wahl 2014 gewonnen hat',
  icon: 'change'
}, {
  name: 'true',
  label: 'Ehrliche Wahlkarte',
  description: 'Hier sind Nichtwähler die stärktste Kraft',
  icon: 'nope',
  text: `
    Wenn man Nichtwähler als eine Partei betrachtet, dann wären sie die stärkste Kraft. Diese Liste zeigt, von wieviel Prozent aller Wahlberechtigten die Parteien wirklich gewählt wurden.
  `,
  calculateResult: true
}*/];

// add area based analysis parts
if (baseconfig.analysis) {
  config = config.concat(baseconfig.analysis);
}

// if (baseconfig.app.analysisIntro && !is768Query()) {
//   config = [{ name: 'intro', label: 'Wahl-Analyse', description: baseconfig.app.analysisIntroHtml }, ...config]
// }

if (!baseconfig.app.has2014Data) {
  config = config.filter(c => c.name !== 'change');
}

export default config;
